import React, { useMemo } from 'react';
import { useCurrentDossierCtx } from '@europrocurement/l2d-modules/modules/Dossiers/providers/CurrentDossierProvider';
import { SirenRneContext } from './SirenRneContext';

const SirenRneProvider: React.FunctionComponent<{ children: React.ReactNode }> = function ({
    children,
}) {
    const { dossier } = useCurrentDossierCtx();

    const value = useMemo(() => ({ currentSousClient: undefined, dossier }), [dossier]);

    return <SirenRneContext.Provider value={value}>{children}</SirenRneContext.Provider>;
};

export default SirenRneProvider;
